<template lang="pug">
modal#delete-account-review-actions-organizations-owner-modal.modal.fade(
  :close-button-label='$t("modal.deleteAccountReviewActionsOrganizationsModal.closeButtonLabel")'
  :disable-process-button='disableProcessButton'
  :loading='loading'
  :process-button-label='$t("modal.deleteAccountReviewActionsOrganizationsModal.processButtonLabel")'
  :remove-close-button='true'
  :title='$t("modal.deleteAccountReviewActionsOrganizationsModal.title")'
  @process='submit'
  data-bs-backdrop='static'
  data-bs-keyboard='false'
  processButtonClass='btn-primary'
  ref='modal'
  size='lg'
)
  .text-center
    div
      p.text-start(v-if='hasItemsForReview') {{ $t('modal.deleteAccountReviewActionsOrganizationsModal.message') }}
      p.text-start(v-else) {{ $t('modal.deleteAccountReviewActionsOrganizationsModal.messageFallback') }}
      p.text-start.mb-0 {{ $t('modal.deleteAccountReviewActionsOrganizationsModal.userAccount') }}
      .mt-1.delete-account-organizations-owner-modal__list
        generic-card.mb-3(
          :message='genericCardMessage'
          :title='genericCardTitle'
          icon-name='user-xmark'
        )
      p.text-start.mb-0(v-if='hasItemsForReview') {{ $t('modal.deleteAccountReviewActionsOrganizationsModal.organizations') }}
      .mt-1(v-if='hasItemsForReview')
        .delete-account-organizations-owner-modal__list
          review-actions-organization-owner-card.mb-3(
            :key='item.organizationId'
            :reviewItem='item'
            @continue
            v-for='item in reviewItems'
          )
      p.organization-owner-card__alert
        | {{ $t('modal.deleteAccountReviewActionsOrganizationsModal.anonymizationWarning') }}
      .form-check.mt-3.text-start
        input#review-anonymization-actions.form-check-input(
          type='checkbox'
          v-model='accepted'
        )
        label.form-check-label(for='review-anonymization-actions') {{ $t('modal.deleteAccountReviewActionsOrganizationsModal.confirm') }}
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import Modal from '@/ui/molecules/Modal.vue';
import ImageLoader from '@/ui/molecules/ImageLoader.vue';
import ReviewActionsOrganizationOwnerCard from '@/modules/account/components/molecules/ReviewActionsOrganizationOwnerCard.vue';
import GenericCard from '@/modules/account/components/molecules/GenericCard.vue';

export default {
  name: 'DeleteAccountReviewActionsOrganizationsOwnerModal',
  components: {
    GenericCard,
    ReviewActionsOrganizationOwnerCard,
    Modal,
    Icon,
    ImageLoader,
  },
  props: {
    organizationDecisions: {
      type: Array,
    },
    reviewItems: {
      type: Array,
    },
  },
  data() {
    return {
      loading: false,
      accepted: false,
    };
  },
  async mounted() {},
  computed: {
    hasItemsForReview() {
      return this.reviewItems.length > 0;
    },
    disableProcessButton() {
      if (!this.loading && !this.hasItemsForReview && this.accepted) {
        return false;
      }
      if (!this.organizationDecisions.length || !this.hasItemsForReview) {
        return true;
      }
      if (!this.accepted) {
        return true;
      }
      return false;
    },
    genericCardTitle() {
      return this.$t(
        'modal.deleteAccountReviewActionsOrganizationsModal.yourAccountCard.title'
      );
    },
    genericCardMessage() {
      return this.$t(
        'modal.deleteAccountReviewActionsOrganizationsModal.yourAccountCard.message'
      );
    },
  },
  methods: {
    submit() {
      this.$emit('process', this.organizationDecisions);
    },
  },
};
</script>
<style scoped>
.delete-account-organizations-owner-modal__list {
  max-height: calc(100vh - 640px);
  overflow-y: auto;
  padding-right: 8px;
}

.organization-owner-card__alert {
  font-size: 14px;
  background-color: #fff6e5;
  border: 1px solid #fff3cd;
  border-radius: 10px;
  padding: 16px;
  color: #013d52;
}
</style>
